import React, { ReactNode, useContext, useEffect, useState } from 'react';

import NetworkContext from '@totem/components/portfolio/buildings/details/network/networkContext';
import { GraphData } from '@totem/components/portfolio/buildings/details/network/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';
type Props = {
  deviceId: string;
  children?: ReactNode;
};
const NetworkLinksContainer = ({ deviceId, children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [data, setData] = useState<GraphData>(null);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);

      setIsLoading(true);

      fetch(`${DEVICES_ENDPOINT}/network/links/${deviceId}`, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => res.json())
        .then((result: GraphData) => {
          setData(result);
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [refreshData, getApiToken]);
  return (
    <NetworkContext.Provider
      value={{
        data,
        isLoading,
        requestRefresh: () => setRefreshData(true),
      }}
    >
      <div>{children}</div>
    </NetworkContext.Provider>
  );
};
export default NetworkLinksContainer;
